import { SpeedDial as SpeedDials } from 'primereact/speeddial';  

const SpeedDial = ({...rest}) => {

    return (
        <SpeedDials {...rest} />
    )

};

export default SpeedDial;